import { defineMessages, IntlShape } from "react-intl";

import PinLegendClassificationType from "@mapmycustomers/shared/enum/pinLegends/PinLegendClassificationType";

const messages = defineMessages<PinLegendClassificationType>({
  [PinLegendClassificationType.EQUAL_INTERVAL]: {
    id: "pinLegendClassification.equalInterval",
    defaultMessage: "Equal Interval",
  },
  [PinLegendClassificationType.MANUAL]: {
    id: "pinLegendClassification.manual",
    defaultMessage: "Manual",
  },
  [PinLegendClassificationType.NATURAL_BREAKS]: {
    id: "pinLegendClassification.naturalBreaks",
    defaultMessage: "Natural Breaks",
  },
  [PinLegendClassificationType.QUANTILE]: {
    id: "pinLegendClassification.quantile",
    defaultMessage: "Quantile",
  },
  [PinLegendClassificationType.SIMPLE]: {
    id: "pinLegendClassification.simple",
    defaultMessage: "Simple",
  },
});

const getPinLegendClassificationDisplayName = (
  intl: IntlShape,
  classification: PinLegendClassificationType
) => intl.formatMessage(messages[classification]);

export default getPinLegendClassificationDisplayName;
